<span class="time-ago">
  @if (timeAgo$ | async; as timeAgo) {
    {{ buildTranslationKey(timeAgo) | translate: { num: timeAgo.num } }}
  }
</span>
<span class="date">
  {{ date | date: dateFormat }}
</span>
